export async function requestNotificationPermission(): Promise<boolean> {
    if (!('Notification' in window)) return false;

    const permission = await Notification.requestPermission();
    return permission === 'granted';
}

export function listenForSubmissionSuccess(onSuccess: () => void): () => void {
    const handler = (event: MessageEvent) => {
        if (event.data?.type === 'SUBMISSION_SUCCESS') {
            onSuccess();
        }
    };

    navigator.serviceWorker.addEventListener('message', handler);
    return () => navigator.serviceWorker.removeEventListener('message', handler);
}